var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 2,
    viewBox: "0 0 15 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1499 1.40002C14.1499 1.54921 14.0906 1.69228 13.9852 1.79777C13.8797 1.90326 13.7366 1.96252 13.5874 1.96252H1.2124C1.06322 1.96252 0.920144 1.90326 0.814655 1.79777C0.709166 1.69228 0.649902 1.54921 0.649902 1.40002C0.649902 1.25084 0.709166 1.10777 0.814655 1.00228C0.920144 0.896788 1.06322 0.837524 1.2124 0.837524H13.5874C13.7366 0.837524 13.8797 0.896788 13.9852 1.00228C14.0906 1.10777 14.1499 1.25084 14.1499 1.40002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.9aba29af071cbf8f635161e2a7cf1c10.svg";
export { ForwardRef as ReactComponent };